import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getPaymentMethodList } from "../../services/paymentMethod.service";
import { OPTIONS_TOAST } from "../../shared/consts";

const initialState = {
  isLoading: false,
  list: [],
  currentPageList: 1,
  totalPageList: 1,
  sizePageList: 1,
  errorMsg: null,
};

/** SLICES */
export const paymentMethodSlice = createSlice({
  name: "paymentMethod",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPaymentMethodList.pending, (state, action) => {
      return { ...state, isLoading: true };
    });
    builder.addCase(getPaymentMethodList.fulfilled, (state, action) => {
      if (action.payload) {
        const data = action.payload.data;
        return {
          ...state,
          isLoading: false,
          list: data,
          errorMsg: null,
        };
      }
      return state;
    });
    builder.addCase(getPaymentMethodList.rejected, (state, action) => {
      toast.dismiss();
      toast.error(`${action.payload}`, OPTIONS_TOAST);
      return {
        ...state,
        isLoading: false,
        errorMsg: action.payload,
      };
    });
  },
});

// export const { } = paymentMethodSlice.actions;
export default paymentMethodSlice.reducer;
